import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import MapToolLayout from './layouts/MapToolLayout';
import PerformanceMonitor from './performance-monitor/PerformanceMonitor';

const MapToolRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><MapToolLayout /></AuthGuard>}>
                <Route path="performance-monitor" element={<PerformanceMonitor />} />
            </Route>
        </Routes>
    );
};

export default MapToolRoutes;

